import * as Sentry from '@sentry/browser';

export default () => {
  const {dsn, environment, version: release} = window.__STATE__.sentry;

  Sentry.init({dsn, release, environment});
};
